<template>
  <div class="bill-checkout-form">
    <div :style="textInfo">
      <p class="text-dark font-size-h5 font-weight-bold">Thông tin kho</p>
    </div>
    <b-form-group>
      <!-- <label class="required-control">
        Cửa hàng:<b class="text-danger">*</b>
      </label> -->
      <treeselect
        ref="store-option"
        :options="optionStores"
        :multiple="false"
        placeholder="Nhập cửa hàng"
        retryText="Thử lại..."
        retryTitle="Nhấp thử lại"
        loadingText="Đang tải..."
        noResultsText="Không có kết quả"
        :match-keys="['label', 'shortName']"
        v-model="billModel.storeId"
        @select="onSelectStore"
        :disabled="billModel.id"
      />
      <b-form-invalid-feedback :state="validateState('searchStore')">
        Vui lòng nhập cửa hàng
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group>
      <label class="lable-form">Chiết khấu:</label>
      <b-row>
        <b-col class="pr-0" cols="3">
          <b-form-select
            class="select-style"
            v-model="billModel.discountType"
            :options="listAmountType"
            size="sm"
            value-field="id"
            text-field="name"
          >
          </b-form-select>
        </b-col>
        <b-col class="pl-0" cols="9">
          <BInputNumber
            v-model="billModel.discountAmount"
            placeholder="Chiết khấu"
            :inputClass="'input-style text-right'"
          />
        </b-col>
      </b-row>
    </b-form-group>
    <div class="row-center-vertical">
      <b-col md="6" class="no-side">
        <p class="textPayment">Thanh toán</p>
      </b-col>
      <b-col md="6" class="no-side">
        <p class="textPoint text-right" v-if="billModel.isCountPoint">
          {{ 0 }} điểm
        </p>
      </b-col>
    </div>
    <b-row class="mb-1">
      <b-col md="6">
        <b class="text-success"> Tổng trước chiết khấu: </b>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(totalBillAmount + totalDiscount) }}
        </span>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <b-col md="6">
        <b class="textTitlePayment text-warning">Tổng chiết khấu:</b>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(totalDiscount) }}
        </span>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <b-col md="6">
        <b class="textTitlePayment text-primary">Tổng tiền:</b>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(totalBillAmount) }}
        </span>
      </b-col>
    </b-row>
    <b-row class="mb-1" v-if="billModel.customerShipFee > 0">
      <b-col md="6">
        <span class="textTitlePayment"> Phí ship: </span>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(billModel.customerShipFee) }}
        </span>
      </b-col>
    </b-row>
    <b-row class="mb-1" v-if="billModel.customerShipFee > 0">
      <b-col md="6">
        <span class="textTitlePayment"> Tổng tiền phải trả: </span>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(totalBillAmount + billModel.customerShipFee) }}
        </span>
      </b-col>
    </b-row>
    <b-row v-if="totalPaid > 0" class="mb-1">
      <b-col md="6">
        <span class="textTitlePayment"> Khách đã đưa: </span>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(totalPaid) }}
        </span>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <b-col md="6">
        <span class="textTitlePayment"> Khách cần trả: </span>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(finalAmount) }}
        </span>
      </b-col>
    </b-row>
    <BillPayment
      ref="bill-payment"
      :finalAmount="finalAmount"
      :billData="billModel"
      :onSubmiting="onPaymentSubmiting"
      :disabled="false"
      :isAllowQRCode="false"
      v-on:onUpdate="onUpdatePayment"
      v-on:receive-payment="onUpdatePayment"
      v-on:receive-payment-mul="onUpdatePaymentV2"
    />
  </div>
</template>

<script>
import apiCommonMixin from '@/view/mixins/api-common.mixins.js';
import calculateMixin from '@/view/mixins/calculate.mixins.js';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';
import { convertPrice, cloneDeep } from '@/utils/common';
import { PAYMENT_TYPE } from '@/utils/enum';
import BillPayment from './BillPayment.vue';

export default {
  mixins: [apiCommonMixin, calculateMixin],
  props: {
    billModel: Object,
  },
  data() {
    return {
      optionStores: null,
      listAmountType: [
        {
          id: 1,
          name: '$',
        },
        {
          id: 2,
          name: '%',
        },
      ],
      onPaymentSubmiting: false,
      textInfo: {
        alignItems: 'center',
        display: 'flex',
        marginTop: '8px',
        marginBottom: '0px',
      },
    };
  },
  components: {
    Treeselect,
    BInputNumber,
    BillPayment,
  },
  computed: {
    totalDiscount() {
      const billItemDiscount = this.calculateTotalDiscountItems(
        this.billModel.billItems,
      );
      const billItemAmount = this.calculateAmountBillItems(
        this.billModel.billItems,
      );
      const discountAmount = this.calculateDiscountAmount(
        this.billModel.discountAmount,
        this.billModel.discountType,
        billItemAmount,
      );
      return billItemDiscount + discountAmount;
    },
    totalBillAmount() {
      const billItemAmount = this.calculateAmountBillItems(
        this.billModel.billItems,
      );
      const discountAmount = this.calculateDiscountAmount(
        this.billModel.discountAmount,
        this.billModel.discountType,
        billItemAmount,
      );
      return billItemAmount - discountAmount;
    },
    totalPaid() {
      const _moneyPaid = this.billModel.moneyPaid
        ? Number(this.billModel.moneyPaid)
        : 0;
      const _moneyTransfered = this.billModel.moneyTransfered
        ? Number(this.billModel.moneyTransfered)
        : 0;
      const _moneyCredit = this.billModel.moneyCredit
        ? Number(this.billModel.moneyCredit)
        : 0;
      const _moneyInstallment = this.billModel.moneyInstallment
        ? Number(this.billModel.moneyInstallment)
        : 0;
      return _moneyPaid + _moneyTransfered + _moneyCredit + _moneyInstallment;
    },
    finalAmount() {
      if (!this.totalBillAmount) {
        return 0;
      }
      const customerShipFee = Number(this.billModel.customerShipFee) || 0;
      const final = this.totalBillAmount - this.totalPaid + customerShipFee;
      return final || 0;
    },
  },
  watch: {
    'billModel.storeId': {
      handler(newVal) {
        if (this.billModel.id) {
          this.optionStores = [
            {
              id: newVal,
              label: this.billModel.storeName || null,
            },
          ];
        }
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.billModel.storeId) {
      this.optionStores = [
        {
          id: this.billModel.storeId,
          label: this.billModel.storeName || null,
        },
      ];
    } else {
      const { stores, currentStoreId, currentStoreName } =
        await this.fetchStoreByUser();

      this.optionStores = this.mapDataTreeSelect(stores, [
        'id',
        'name',
        'shortName',
      ]);

      if (currentStoreId) {
        this.billModel.storeId = currentStoreId;
        this.billModel.storeName = currentStoreName;
      }
    }
  },
  methods: {
    convertPrice,
    onSelectStore(node) {
      if (node.id && node.id !== this.billModel.storeId) {
        this.billModel.storeId = node.id;
        this.billModel.storeName = node.label;
      } else {
        this.billModel.storeId = null;
        this.billModel.storeName = null;
      }
    },
    validateState(name) {
      if (!name) return null;
    },
    mapDataTreeSelect(items = [], keys = []) {
      return items.map((element) => {
        return {
          id: element[keys[0]],
          label: element[keys[1]],
          shortName: element[keys[2]],
        };
      });
    },
    onUpdatePayment(paymentInfo) {
      this.billModel.paymentInfo = cloneDeep(paymentInfo);
    },
    onUpdatePaymentV2(items = [], type) {
      const payments = items.reduce((result, current) => {
        result.push({
          ...current,
          paymentAmount: current.paymentAmount,
        });
        return result;
      }, []);
      switch (type) {
        case PAYMENT_TYPE.INSTALLMENT: {
          this.billModel.installments = payments;
          break;
        }
        case PAYMENT_TYPE.CREDIT: {
          this.billModel.credits = payments;
          break;
        }
        case PAYMENT_TYPE.TRANSFER: {
          this.billModel.transfer = payments;
          break;
        }
        case PAYMENT_TYPE.CASH: {
          this.billModel.cash = payments;
          break;
        }
        case PAYMENT_TYPE.REFUND: {
          this.billModel.refunds = payments;
          break;
        }
      }
    },
    validatePayment() {
      if (this.$refs['bill-payment']) {
        // Set onSubmiting to true before validation
        this.onPaymentSubmiting = true;
        const isValid = this.$refs['bill-payment'].validateAll();
        // Reset onSubmiting if validation fails
        if (!isValid) {
          this.onPaymentSubmiting = false;
        }
        return isValid;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
.bill-checkout-form {
  .vue-treeselect__input-container {
    padding-top: 0px;
  }

  .vue-treeselect__control {
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    height: 2.5rem;
  }

  .vue-treeselect--has-value .vue-treeselect__multi-value {
    margin-bottom: 2px;
  }

  .header-color {
    color: rgb(24, 28, 50);
  }
  .text-note {
    font-size: 12px;
    font-style: italic;
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -webkit-pre-wrap; /* Chrome & Safari */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* CSS3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    word-break: break-word;
    white-space: normal;
  }
  .row-center-vertical {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .textPayment {
    font-size: 16px;
    font-weight: 500;
    color: brown;
  }
}
</style>
